import { defineComponent as _defineComponent } from 'vue'

interface Coordinates {
  x: number
  y: number
}

type Anchor = Element | Coordinates

const __default__ = {}
export { OzBoxColors as OzBasePopoverColors } from '@@/library/v4/components/OzBox.vue'
export type { Anchor }

import OzBox, { type OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import { useFloating } from '@@/vuecomposables/floating'
import type { ComputePositionConfig, ReferenceElement } from '@floating-ui/vue'
import { computed, ref, watch } from 'vue'

/* ---------------------- */
/* INTRODUCTION           */
/* ---------------------- */
/**
 * OzBasePopover is the base component for all our popovers.
 * It's not meant to be used directly, since it doesn't have a semantic representation.
 * Instead, it just acts as the core piece that encapsulates logic that
 * doesn't need to be visible or handled on the implementation phase.
 */


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzBasePopover',
  props: {
    anchor: null,
    config: null,
    darkMode: { type: [Boolean, String], default: 'auto' },
    radius: { default: undefined },
    color: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { anchor: Anchor, config: Partial<ComputePositionConfig>, darkMode: boolean | 'auto', radius: 0 | 8 | 12 | 16 | 20 | 24, color: OzBoxColors }



/**
 * The `floating` composable requires us to
 * pass the reference of the anchor element.
 * Since we want to keep the API simple, we'll handle
 * the reference internally by watching the passed prop.
 */
const anchorRef = ref<ReferenceElement | null>(null)

const isCoordinates = (anchor: Anchor): boolean => {
  return Object.hasOwn(anchor, 'x') && Object.hasOwn(anchor, 'y')
}

const getDomRectFromCoordinates = (element: Coordinates): DOMRect => {
  return new DOMRect(element.x, element.y, 0, 0)
}

watch(
  () => props.anchor,
  (el: Anchor): void => {
    if (isCoordinates(el)) {
      anchorRef.value = { getBoundingClientRect: () => getDomRectFromCoordinates(el as Coordinates) }
      return
    }
    anchorRef.value = el as ReferenceElement
  },
  { immediate: true },
)

const popover = ref<OzBox | null>(null)
const popoverEl = computed(() => popover.value?.$el)
const { floatingStyles } = useFloating(anchorRef, popoverEl, {
  ...props.config,
})

return { __sfc: true,props, anchorRef, isCoordinates, getDomRectFromCoordinates, popover, popoverEl, floatingStyles, OzBox }
}

})